import { makeStyles } from "@mui/styles";

export default makeStyles(() => ({
    paper: {
        height: '4rem',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    search: {
        height: '80%',
        marginTop: '-1rem'
    },
}))